import fire from "../../../services/fire";

export async function getBulletin(parish) {
  try {
    const querySnapshot = await fire
      .firestore()
      .collection("bulletin")
      .where("parish", "==", parish)
      .orderBy("created", "desc")
      .limit(10)
      .get();

    const list = [];
    let count = 0;
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      let showPreview = true;
      if (count >= 2) {
        showPreview = false;
      }
      list.push({ ...data, showPreview: showPreview });
      count++;
    });
    return list;
  } catch (error) {
    console.error("Bulletin collection not yet created", error);
  }
  return [];
}
